module.exports = __webpack_public_path__ + "img/06.2a03001a.png";